import { render, staticRenderFns } from "./IconGroup.vue?vue&type=template&id=1a8e3892&"
import script from "./IconGroup.vue?vue&type=script&lang=js&"
export * from "./IconGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports